/*
 *
 *@description:     tip 提示语弹窗
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-09-22 09:53:25
 *
*/
import './style.less';

interface obj {
  [index: string]: any
};

let tiptoast = {
  show(opt: any) {
    let defaultopt = {
      content: "",
      callback: null,
      showtime: 3000,
      classStyle: "tiptoastmodal",
      boxid: "body"
    }
    let options: obj = $.extend({}, defaultopt, opt);
    $("." + `${options.classStyle}`).remove();
    
    let htmlstr = `<div class="${options.classStyle}">${opt.content}</div>`
    $(options.boxid).append($(htmlstr)); 

    if (options.callback) {
      setTimeout(() => {
        options.callback();
      }, options.showtime);
    }
    $("." + `${options.classStyle}`).fadeOut(options.showtime);

  }

}

export default tiptoast;